import { useCallback } from 'react';
import { LOG_ACTIONS, logAction } from '@namespace/analytics';
import { COOKIES_KEYS, setCookie } from '@namespace/helpers';

export const useOldVersion = () =>
  useCallback(() => {
    setCookie(COOKIES_KEYS.OLD_VERSION, true, { expires: 7 });
    logAction(LOG_ACTIONS.GO_OLD_VERSION);
  }, []);
